import { render } from "./BackButton.vue?vue&type=template&id=ec356664&scoped=true"
import script from "./BackButton.vue?vue&type=script&lang=js"
export * from "./BackButton.vue?vue&type=script&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=ec356664&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-ec356664"

export default script